// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"c3da5700","498":"6aa16501","513":"71f09128"}[chunkId] + ".chunk.js";
};